import type { QueryClient } from '@tanstack/react-query'

const CAMPAIGNS_PATH = '/api/v1/campaigns'

/**
 * A campaign write moves more than the record it touched: pausing changes the
 * index tab counts, the summary strip and the detail header at once; removing
 * people changes every contact chip and the activity feed. Rather than name
 * the keys per mutation (and miss one), any write drops every
 * `/api/v1/campaigns/**` query and lets the mounted screens refetch.
 */
export function invalidateCampaignQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({
    predicate: (query) =>
      JSON.stringify(query.queryKey).includes(CAMPAIGNS_PATH),
  })
}
